import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import utils from '../utils/utils'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { keepAlive: false }
  },
  {
    path: '/class_expire',
    name: 'class_expire',
    component: () => import('../views/Class_Expire.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/my_works',
    name: 'my_works',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "my_works" */ '../views/My_works.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/work_detail',
    name: 'work_detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "work_detail" */ '../views/Work_detail.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/visit_class',
    name: 'visit_class',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "visit_class" */ '../views/Visit_class.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/question_bank',
    name: 'question_bank',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "question_bank" */ '../views/Question_bank.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/question_bank_center',
    name: 'question_bank_center',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "question_bank_center" */ '../views/Question_bank_center.vue'),
    meta: { keepAlive: false }
  },

  {
    path: '/exam_list',
    name: 'exam_list',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "exam_list" */ '../views/Exam_list.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/exam',
    name: 'exam',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "exam" */ '../views/Exam.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/my_questions',
    name: 'my_questions',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "my_questions" */ '../views/My_questions.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/my_questions_d',
    name: 'my_questions_d',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "my_questions_d" */ '../views/My_questions_detail.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/playback',
    name: 'playback',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "playback" */ '../views/Playback.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/report',
    name: 'report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "report" */ '../views/Report.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/exercise',
    name: 'exercise',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "exercise" */ '../views/Exercise.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/exercise_list',
    name: 'exercise_list',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "exercise_list" */ '../views/Exercise_list.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/assemble',
    name: 'assemble',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "assemble" */ '../views/Assemble.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/handouts',
    name: 'handouts',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "handouts" */ '../views/Handouts.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/handout_detail',
    name: 'handout_detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "handout_detail" */ '../views/Handouts_detail.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/handout_see',
    name: 'handout_see',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "handout_see" */ '../views/Handouts_see.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/join',
    name: 'join',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "join" */ '../views/Join.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/exam_work',
    name: 'exam_work',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "exam_work" */ '../views/Exam_works.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/class_schedule',
    name: 'class_schedule',
    // eslint-disable-next-line space-in-parens
    component: () => import( /* webpackChunkName: "class_schedule" */ '../views/Class_Schedule.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/mock_index',  //模考页
    name: 'mock_index',
    // eslint-disable-next-line space-in-parens
    component: () => import( /* webpackChunkName: "class_schedule" */ '../views/mock.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/mock_report',  //模考页
    name: 'mock_index',
    // eslint-disable-next-line space-in-parens
    component: () => import( /* webpackChunkName: "class_schedule" */ '../views/mock.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/mock_ranking',  //模考页
    name: 'mock_index',
    // eslint-disable-next-line space-in-parens
    component: () => import( /* webpackChunkName: "class_schedule" */ '../views/mock.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/mock_sign_up',  //模考页
    name: 'mock_index',
    // eslint-disable-next-line space-in-parens
    component: () => import( /* webpackChunkName: "class_schedule" */ '../views/mock.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/memories_index',  //考生回忆，相关重定向处理
    name: 'memories_index',
    // eslint-disable-next-line space-in-parens
    component: () => import( /* webpackChunkName: "class_schedule" */ '../views/memories_index.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/memories_details",
    redirect: "/memories_index"
  },
  {
    path: "/memories_lookExam",
    redirect: "/memories_index"
  },
  {
    path: "/memories_vote",
    redirect: "/memories_index"
  },
  {
    path: "/memories_voteDetails",
    redirect: "/memories_index"
  },
  {
    path: '/examMoni_index',
    name: 'examMoni_index',
    component: () => import('../views/exam_moni/index.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/examMoni_logon',
    name: 'examMoni_logon',
    component: () => import('../views/exam_moni/logon.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/examMoni_before',
    name: 'examMoni_before',
    component: () => import('../views/exam_moni/before.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/examMoni_question',
    name: 'examMoni_question',
    component: () => import('../views/exam_moni/question.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/examMoni_success',
    name: 'examMoni_success',
    component: () => import('../views/exam_moni/success.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/fkxly',
    name: 'fkxly',
    component: () => import('../views/fkxly.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/mockZujuan',
    name: 'mockZujuan',
    component: () => import('../views/Mock_zujuan.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/questionLog',
    name: 'questionLog',
    component: () => import('../views/questionLog.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/superClass',
    name: 'superClass',
    component: () => import('../views/superClass.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/wrongTopic',
    name: 'wrongTopic',
    component: () => import('../views/wrongTopic.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/collectTopic',
    name: 'collectTopic',
    component: () => import('../views/collectTopic.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/brzsd',
    name: 'brzsd',
    component: () => import('../views/Brzsd.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/workZsdxx',
    name: 'workZsdxx',
    component: () => import('../views/workZsdxx.vue'),
    meta: { keepAlive: true }
  },
  {
    path: '/playbackZsd',
    name: 'playbackZsd',
    component: () => import('../views/playbackZsd.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/reportZujuan',
    name: 'reportZujuan',
    component: () => import('../views/Report_zujuan.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/knowledgeStudy',
    name: 'knowledgeStudy',
    component: () => import('../views/knowledgeStudy.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/readJY',
    name: 'readJY',
    component: () => import('../views/ReadJY.vue'),
    meta: { keepAlive: false }
  },
  {
    path: '/aiExamList',
    name: 'aiExamList',
    component: () => import('../views/Ai_exam_list.vue'),
    meta: { keepAlive: false }
  },
  






  {
    path: "*",
    redirect: "/"
  }
]

const router = new VueRouter({
  routes
})

// 前置路由守卫
router.beforeEach((to, from, next)=> {
  utils.recoverCopy()
  next()
});

export default router
